import React, { useEffect, useState } from "react";
import {
  Offcanvas,
  Button,
  Row,
  Col,
  Image,
  Form,
  Modal,
  Spinner,
} from "react-bootstrap";
import { FaTrashAlt } from "react-icons/fa";
import { MdOutlineShoppingCartCheckout } from "react-icons/md";
import "../css/cart.css";
import {
  formatDate,
  getImage,
  formatNumberConditionalDecimal,
} from "../utils/gblFunc";
import MessageModal from "./MessageModal";
import { useTranslation } from "react-i18next";
import { ApplicationContext } from "../Context/AppContext";
import logo from "../Assets/Images/logo.png";
import Login from "./Login";
import UserAddress from "./UserAddress";
import {
  addToCart_Data,
  deleteFromCart_Data,
  setDefaultAddress,
  saveOrder_Data,
  saveOrder_Master,
  getDiscount_Data,
  generateRazorPay_Order,
  rPay_verifyPayment,
  rPay_paymentFailed,
  getPublic_GstRate,
  calculate_ShippingCharge,
} from "../Services/client";
import FullPageLoader from "./FullPageLoader";
import { useNavigate } from "react-router-dom";
import { encodeId } from "../utils/idUtils";
import { gaRemoveFromCart, gaBeginCheckout, gaPurchase } from "../utils/analytics";
import { Calculator } from "lucide-react";
import { getCompany_Info } from "./../Services/client";
import { FaTimes, FaCheck } from "react-icons/fa";

const Cart = ({ show, closeItemCart }) => {
  const [showCart, setShowCart] = useState(show == true ? true : false);

  // Cart stays mounted across the Razorpay payment flow (so the
  // success/failure MessageModal can still be shown), so the offcanvas's
  // own `showCart` state can drift out of sync with the `show` prop Header
  // passes down. Without this, re-clicking the cart badge after a payment
  // attempt does nothing, because Header's `show` value never actually
  // changes (it was never set back to false), and `show`'s initial value
  // is only consumed once by useState above.
  useEffect(() => {
    setShowCart(show);
  }, [show]);
  const [discountCode, setDiscountCode] = useState("");
  const [subtotal, setSubTotal] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [gst, setGst] = useState(0);
  const [totals, setTotals] = useState(0);
  const [cartItems, setCartItems] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [msgTitle, setmsgTitle] = useState("");
  const [msgMessage, setMsgMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  const [msgConfirmFunc, setMsgConfirmFunc] = useState(null);
  const [showLinkButtonOnDialog, setShowLinkButtonOnDialog] = useState(false);
  const [dialogOnClickFunc, setDialogOnClickFunc] = useState(null);
  const { cartCount, setCartCount } = ApplicationContext();
  const [companyInfo, setCompanyInfo] = useState({});
  const [showAddressPanel, setShowAddressPanel] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [showLogin, setShowLogin] = useState(false);
  const [showUserAddress, setShowUserAddress] = useState(false);
  const [selAddressToEditId, setSelAddressToEditId] = useState(0);
  const { t, i18n } = useTranslation();
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [deliveryAddress, setDeliveryAddress] = useState({});
  const [reload, setReload] = useState(false);
  const [gstRate, setGstRate] = useState(0.18); // default 18% until fetched
  const [shippingCharge, setShippingCharge] = useState(0);
  const [shippingNote, setShippingNote] = useState("");
  const [shippingError, setShippingError] = useState("");
  const [shippingProvider, setShippingProvider] = useState("");
  const [shippingLoading, setShippingLoading] = useState(false);
  const [couponMessage, setCouponMsgMessage] = useState("");
  const [showQtyExceedMsg, setShowQtyExceedMsg] = useState(false);
  const [redirectHomeOnClose, setRedirectHomeOnClose] = useState(false);
  const userMobile = localStorage.getItem("userMobile");
  const storedCart = JSON.parse(localStorage.getItem("cartItems") || "[]");
  const userAddress = JSON.parse(localStorage.getItem("userAddress") || "[]");
  const userId = localStorage.getItem("userId");

  const navigate = useNavigate();
  const unitMap = {
    kg: t("kg"),
    grm: t("gm"),
  };

  useEffect(() => {
    setTimeout(() => {
      const storedCart = JSON.parse(localStorage.getItem("cartItems")) || [];
      setCartItems(storedCart);
      const delveryAdd = JSON.parse(localStorage.getItem("deliveryAddress"));
      setDeliveryAddress(delveryAdd);
    }, 500);
  }, [reload]);

  useEffect(() => {
    getCompanyInfo();
    fetchGstRate();
  }, [localStorage.getItem("i18nextLng")]);

  // Re-calculate shipping whenever cart items or delivery address changes
  useEffect(() => {
    if (cartItems.length > 0) {
      // Read pin directly from localStorage in case state hasn't updated yet
      const addr = deliveryAddress?.pin
        ? deliveryAddress
        : JSON.parse(localStorage.getItem("deliveryAddress") || "null");
      const pin = addr?.pin || addr?.pincode || null;
      fetchShippingCharge(cartItems, pin);
    } else {
      setShippingCharge(0);
      setShippingNote("");
    }
  }, [cartItems, deliveryAddress]);

  const fetchShippingCharge = async (items, pincode) => {
    setShippingLoading(true);
    try {
      const res = await calculate_ShippingCharge(items, pincode);
      if (res?.data?.success) {
        if (res.data.deliverable === false) {
          setShippingCharge(0);
          setShippingNote("");
          setShippingProvider("");
          setShippingError(res.data.message || "Delivery not available at this location.");
        } else {
          setShippingCharge(Number(res.data.charge) || 0);
          setShippingNote(res.data.note || "");
          setShippingProvider(res.data.provider || "");
          setShippingError("");
        }
      }
    } catch {
      // keep existing charge
    } finally {
      setShippingLoading(false);
    }
  };

  const fetchGstRate = async () => {
    try {
      const res = await getPublic_GstRate();
      if (res?.data?.success && res.data.data?.gst_percentage !== undefined) {
        setGstRate(Number(res.data.data.gst_percentage) / 100);
      }
    } catch {
      // keep default 18%
    }
  };

  const getCompanyInfo = async () => {
    const companyInfo = await getCompany_Info();
    if (companyInfo?.data?.data?.length && companyInfo.status === 200) {
      setCompanyInfo(companyInfo.data.data);
    }
  };

  useEffect(() => {
    calculateTotals();
  }, [cartItems, discount, gstRate, shippingCharge]);

  // useEffect(() => {
  //   if (subtotal > 0) {
  //     checkDiscount();
  //   }
  // }, [subtotal]);

  // Check and calculate discount
  const checkDiscount = async () => {
    if (discountCode === "") {
      setDiscount(0);
      setCouponMsgMessage(t("enter_coupon_code"));
      return;
    }

    const discountResponse = await getDiscount_Data(discountCode, subtotal);
    if (discountResponse.success === false) {
      setCouponMsgMessage(t("invalid_coupon_code"));
      setDiscountCode("");
      setDiscount(0);
    } else {
      const returnData = discountResponse?.data?.discount[0][0];
      if (returnData != undefined && returnData != "undefined") {
        let subtotal = 0;
        let discount = 0;
        cartItems?.map((el) => {
          subtotal =
            subtotal +
            (el?.discount > 0
              ? el.price - (el.price * el?.discount) / 100
              : el.price) *
              (el.qty || 1);
        });

        if (!returnData.isValidAmount) {
          setDiscount(0);
          setCouponMsgMessage(
            `${t("coupon_min_amount_pre")}${returnData.min_amount}${t(
              "coupon_min_amount_post",
            )}`,
          );
          return;
        }
        if (!returnData.isValidDateRange) {
          setDiscount(0);
          setCouponMsgMessage(`The coupon code has expired.`);
          return;
        }

        if (
          returnData.isValidCoupon &&
          returnData.isValidAmount &&
          returnData.isValidDateRange &&
          returnData.discount_type === "Percentage"
        ) {
          discount = subtotal * (returnData.discount_amount / 100);
          if (discount >= returnData.max_discount)
            discount = returnData.max_discount;

          setDiscount(discount);
          setCouponMsgMessage(t("coupon_successfully_mgs"));
          return;
        } else if (
          returnData.isValidCoupon &&
          returnData.isValidAmount &&
          returnData.isValidDateRange &&
          returnData.discount_type === "Fixed"
        ) {
          discount = returnData.discount_amount;
          setDiscount(discount);
          setCouponMsgMessage(t("coupon_successfully_mgs"));
          return;
        }
      } else {
        setDiscount(0);
        setCouponMsgMessage(t("invalid_coupon_code"));
        setDiscountCode("");
        setTimeout(() => {
          setCouponMsgMessage("");
        }, 3000);
      }
    }
  };

  // Calculate order total
  const calculateTotals = () => {
    let subtotal = 0;
    let gst = 0;
    let totals = 0;

    cartItems?.map((el) => {
      subtotal =
        subtotal +
        (el?.discount && el?.discount > 0
          ? el.price - (el.price * el.discount) / 100
          : el.price) *
          (el.qty || 0);
    });
    gst = (subtotal - discount) * gstRate;
    totals = subtotal - discount + gst + shippingCharge;

    setSubTotal(subtotal);
    setGst(gst);
    setTotals(totals);
  };

  const handleClose = () => {
    setShowCart(false);
    setTimeout(() => {
      closeItemCart();
    }, 500);
  };

  const removeItemFromCart = (productId, detailId) => {
    setmsgTitle(t("delete_Item"));
    setMsgMessage(t("delete_confirm_msg"));
    setMsgType(t("confirm"));
    setMsgConfirmFunc(() => () => confirmDelete(productId, detailId));
    setShowModal(true);
    setShowLinkButtonOnDialog(false);
  };

  const confirmDelete = async (productId, detailId) => {
    const itemsLeft = cartItems.filter(
      (el) => el.detailId !== detailId, //el.productId !== productId
    );
    const itemForDelete = cartItems.filter(
      (el) => el.productId === productId && el.detailId === detailId,
    );

    if (itemForDelete.length > 0) {
      const d = itemForDelete[0];
      gaRemoveFromCart({ productId: d.productId, name: d.name, price: Number(d.price), qty: d.qty || 1, unit: d.unit, unitQty: d.unitQty });
    }

    if (itemsLeft.length === 0) {
      localStorage.removeItem("cartItems");
    } else {
      localStorage.setItem("cartItems", JSON.stringify(itemsLeft));
    }
    setCartItems(itemsLeft);
    const totalQty = itemsLeft.reduce((sum, item) => sum + (item.qty || 0), 0);
    setCartCount(totalQty);
    setShowModal(false);
    await deleteCartData(itemForDelete);

    if (itemsLeft.length <= 0) {
      setShowCart(false);
      closeItemCart(false);
    }
  };

  const updateCartData = async (cartData) => {
    try {
      if (userId) {
        const response = await addToCart_Data(cartData, userId);
        if (response.success === false) {
        } else {
        }
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  const deleteCartData = async (cartData) => {
    try {
      const userId = localStorage.getItem("userId");
      if (userId) {
        const response = await deleteFromCart_Data(cartData, userId);
        if (response.success === false) {
        } else {
        }
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  const handleQtyChange = async (productId, detailId, type) => {
    const updatedCart = cartItems.map((item) => {
      if (item.productId === productId && item.detailId === detailId) {
        let newQty = type === "add" ? item.qty + 1 : item.qty - 1;

        if (newQty > item.availQty) {
          setShowQtyExceedMsg(true);
          setTimeout(() => {
            setShowQtyExceedMsg(false);
          }, 3000);
          return item;
        }

        newQty = newQty < 1 ? 1 : newQty;
        return { ...item, qty: newQty };
      }
      return item;
    });

    setCartItems(updatedCart);
    await updateCartData(updatedCart);
    localStorage.setItem("cartItems", JSON.stringify(updatedCart));

    // update cart count
    const totalQty = updatedCart.reduce(
      (sum, item) => sum + (item.qty || 0),
      0,
    );

    setCartCount(totalQty);
  };

  const checkout = () => {
    if (storedCart.length === 0) {
      setmsgTitle(t("no_Items"));
      setMsgMessage(t("no_Items_msg"));
      setMsgType("info");
      setShowModal(true);
      setShowLinkButtonOnDialog(false);
      return;
    }

    if (!userMobile) {
      setShowLogin(true);
      return;
    }

    const deliveryAddress = JSON.parse(localStorage.getItem("deliveryAddress"));
    if (!deliveryAddress) {
      if (userAddress.length === 0) {
        setShowUserAddress(true);
      } else {
        setShowAddressPanel(true);
      }
      return;
    }

    const delAddress = `${deliveryAddress.name} 
                      ${t("email")}: ${deliveryAddress.email}, 
                      ${t("mobile_no")}:${deliveryAddress.mobile_no} 
                      ${t("address1")}: ${deliveryAddress.address1}
                      ${t("address2")}: ${deliveryAddress.address2}
                      ${t("city")}: ${deliveryAddress.city}, ${t("state")}: ${
                        deliveryAddress.state
                      }
                      ${t("pin")}: ${deliveryAddress.pin}`;

    gaBeginCheckout({ cartItems, total: totals, shippingCharge });
    setmsgTitle(t("delivery_address"));
    setMsgMessage(delAddress);
    setMsgType(t("confirm"));
    setMsgConfirmFunc(() => () => confirmPayment());
    setShowModal(true);
    setShowLinkButtonOnDialog(true);
    setDialogOnClickFunc(() => () => {
      setShowModal(false);
      setShowAddressPanel(true);
    });
  };

  const saveOrderMaster = async (userId, totals, discount, addressId) => {
    try {
      const response = await saveOrder_Master(
        userId,
        totals,
        discount,
        addressId,
        shippingCharge,
        shippingProvider,
      );
      return response;
    } catch (err) {
      console.error(err.message);
    }
  };

  const confirmPayment = async () => {
    const deliveryAddress = localStorage.getItem("deliveryAddress");
    const deliveryAddressObj = JSON.parse(deliveryAddress || "null");
    const deliveryAddressId = deliveryAddressObj?.id;
    // Guards against a stray modal-close (ondismiss) firing the failure
    // flow after a payment has already succeeded/failed.
    let settled = false;
    setShowModal(false);
    setShowAddressPanel(false);
    // NOTE: don't call closeItemCart() here — that unmounts this whole
    // Cart component (Header renders it conditionally), which would also
    // destroy the success/failure MessageModal before Razorpay's async
    // handler gets a chance to show it. Just hide the offcanvas panel
    // locally; the component stays mounted (invisible) until the payment
    // flow finishes.
    setShowCart(false);

    try {
      // 1️⃣ Create orderMaster + Razorpay order (BACKEND)
      const response = await saveOrderMaster(
        userId,
        totals,
        discount,
        deliveryAddressId,
      );

      // Guard: if saveOrderMaster returned an error object or no orderId
      if (response?.error || !response?.data?.orderId) {
        setmsgTitle(t("fail_payment_title"));
        setMsgMessage(response?.message || t("fail_payment_msg"));
        setMsgType("info");
        setShowModal(true);
        setShowLinkButtonOnDialog(false);
        return;
      }

      const localOrderId = response.data.orderId;
      if (response.data.success == "true") {
        generateRazorPay_Order(totals, localOrderId).then((razorpayOrder) => {
          // 2️⃣ Open Razorpay checkout
          const options = {
            key: process.env.REACT_APP_RAZORPAY_KEY,
            amount: razorpayOrder.data.amount,
            currency: razorpayOrder.data.currency,

            order_id: razorpayOrder.data.id, // ⭐ REQUIRED

            name: companyInfo?.[0]?.companyname,
            description: "Order Payment",
            image: logo,

            handler: function (razorPayResponse) {
              //verifyPayment and insert data in detail and payment table.
              settled = true;
              rPay_verifyPayment(
                razorPayResponse,
                cartItems,
                localOrderId,
                totals, // ⚠️ was razorpayOrder.data.amount (paise) — backend/processSuccessfulPayment expects rupees, same unit createRazorpayOrder used
              ).then((res) => {
                if (res.data?.success === true) {
                  gaPurchase({
                    orderId:          localOrderId,
                    cartItems,
                    total:            totals,
                    shippingCharge,
                    shippingProvider,
                  });
                  setmsgTitle(t("successful_payment_title"));
                  setMsgMessage(t("successful_payment_msg"));
                  setMsgType("info");
                  setShowModal(true);
                  setShowLinkButtonOnDialog(false);
                  setRedirectHomeOnClose(true);
                  localStorage.removeItem("cartItems"); //clear cart items after successfull payment
                  setCartItems([]);
                  setCartCount(0);
                } else {
                  // Verification failed (bad signature) or the request
                  // itself errored — money may have been captured by
                  // Razorpay but the order wasn't marked successful, so the
                  // user must be told rather than left with no feedback.
                  rPay_paymentFailed(localOrderId).then(() => {
                    setmsgTitle(t("fail_payment_title"));
                    setMsgMessage(t("fail_payment_msg"));
                    setMsgType("info");
                    setShowModal(true);
                    setShowLinkButtonOnDialog(false);
                  });
                }
              });
            },

            prefill: {
              name: deliveryAddressObj?.name || "",
              email: deliveryAddressObj?.email || "",
              contact: deliveryAddressObj?.mobile_no || userMobile || "",
            },

            notes: {
              delivery_address: deliveryAddress,
              order_id: razorpayOrder.data.id,
            },

            theme: { color: "#28a745" },

            modal: {
              // Fires when the user closes the checkout popup without
              // completing or explicitly failing a payment (abandoned
              // checkout). Previously this case had no handling at all.
              ondismiss: function () {
                if (settled) return;
                settled = true;
                rPay_paymentFailed(localOrderId).then(() => {
                  setmsgTitle(t("fail_payment_title"));
                  setMsgMessage(t("fail_payment_msg"));
                  setMsgType("info");
                  setShowModal(true);
                  setShowLinkButtonOnDialog(false);
                });
              },
            },
          };

          const rzp = new window.Razorpay(options);
          rzp.open();

          rzp.on("payment.failed", function () {
            settled = true;
            rPay_paymentFailed(localOrderId).then((res) => {
              if (res.data?.success === true) {
                setmsgTitle(t("fail_payment_title"));
                setMsgMessage(t("fail_payment_msg"));
                setMsgType("info");
                setShowModal(true);
                setShowLinkButtonOnDialog(false);
              }
            });
          });
        });
      }
    } catch (err) {
      console.error("Error creating order", err);
    }
  };

  // const confirmPayment = async () => {
  //   const deliveryAddress = localStorage.getItem("deliveryAddress");
  //   let razorpayOrder = "";
  //   // 1️⃣ Create Razorpay order
  //   generateRazorPay_Order(totals).then((razorpayOrder) => {
  //     console.log("razorpayOrder", razorpayOrder);
  //     // 2️⃣ Open Razorpay checkout
  //     const options = {
  //       key: "rzp_test_RzmatOcSiWUh08",
  //       amount: razorpayOrder.data.amount,
  //       currency: razorpayOrder.data.currency,

  //       order_id: razorpayOrder.data.id, // ⭐ REQUIRED

  //       name: companyInfo?.[0]?.companyname,
  //       description: "Order Payment",
  //       image: logo,

  //       handler: function (razorPayResponse) {
  //         /*
  //         response = {
  //           razorpay_payment_id,
  //           razorpay_order_id,
  //           razorpay_signature
  //         }
  //       */
  //         console.log("razorPayResponse", razorPayResponse, razorpayOrder);
  //         //verifyAndSaveOrder(response);
  //         saveOrder(razorPayResponse, razorpayOrder);
  //       },

  //       prefill: {
  //         name: "Sachin Soni",
  //         email: "sachin@softsal.com",
  //         contact: "9621449376",
  //       },

  //       notes: { delivery_address: deliveryAddress },
  //       theme: { color: "#28a745" },
  //     };

  //     const rzp = new window.Razorpay(options);
  //     rzp.open();
  //   });
  // };

  const editAddress = (selAddressToEdit) => {
    setSelAddressToEditId(selAddressToEdit.id);
    setShowUserAddress(true);
  };

  const addAddress = () => {
    setSelAddressToEditId(0);
    setShowUserAddress(true);
  };

  const setDefaultAdd = async (selAddressToEdit) => {
    setIsLoading(true);
    if (selAddressToEdit.id > 0) {
      try {
        const response = await setDefaultAddress(
          selAddressToEdit.id,
          selAddressToEdit.user_id,
        );
        if (response.success === false) {
        } else {
          localStorage.setItem(
            "userAddress",
            JSON.stringify(response.data.userAddress),
          );
          deliverToThisAddress(selAddressToEdit);
        }
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      } catch (err) {
      }
    }
  };

  const deliverToThisAddress = (deliveryAddress) => {
    if (deliveryAddress) {
      setIsLoading(true);
      localStorage.setItem("deliveryAddress", JSON.stringify(deliveryAddress));
      setDeliveryAddress(deliveryAddress);
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }
  };

  const viewProductInfo = (proId, detId) => {
    setShowCart(false);
    closeItemCart();
    navigate(`/productinfo/${encodeId(proId)}`, {
      state: { detailId: detId },
    });
  };

  const callbackFromAddress = () => {
    setReload(!reload);
  };

  const callbackFromLogin = () => {
    setReload(!reload);
  };

  return (
    <>
      <Offcanvas
        show={showCart}
        onHide={() => {
          handleClose();
        }}
        placement="end"
        scroll={false}
        backdrop={true}
        style={{
          top: "80px",
          height: "calc(100% - 60px)",
          zIndex: 1050,
        }}
        className="cart-offcanvas"
      >
        <Offcanvas.Header className="offcanvas-header" closeButton>
          <Offcanvas.Title className="cart-header">{t("cart")}</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className="d-flex flex-column h-100">
          {/* Not logged in — prompt login */}
          {!userMobile ? (
            <div className="d-flex flex-column align-items-center justify-content-center h-100 text-center px-3">
              <i className="fas fa-shopping-cart" style={{ fontSize: "48px", color: "#ccc", marginBottom: "16px" }} />
              <h6 style={{ color: "#444", marginBottom: "8px" }}>Your cart is waiting for you</h6>
              <p style={{ fontSize: "13px", color: "#888", marginBottom: "20px" }}>
                Log in to see the items you've saved and continue shopping.
              </p>
              <Button
                variant="success"
                size="sm"
                onClick={() => { handleClose(); setShowLogin(true); }}
              >
                Log in to view cart
              </Button>
            </div>
          ) : (
          <>
          {/* Offer Banner */}

          <div className=" mt-0 mb-2">
            <div className="w-100">
              <div>
                <div style={{ fontSize: "13px", fontWeight: 600, marginBottom: "5px", color: "#444" }}>
                  {t("discount")}
                </div>
                <div style={{ display: "flex", gap: "8px" }}>
                  <Form.Control
                    type="text"
                    placeholder={t("enter_coupon_placeholder")}
                    style={{ fontSize: "14px", borderColor: "#aaa" }}
                    value={discountCode}
                    onChange={(e) => setDiscountCode(e.target.value.toUpperCase())}
                    onKeyDown={(e) => e.key === "Enter" && checkDiscount()}
                  />
                  <Button
                    variant="success"
                    size="sm"
                    style={{ whiteSpace: "nowrap", paddingLeft: "16px", paddingRight: "16px" }}
                    onClick={checkDiscount}
                  >
                    {t("apply")}
                  </Button>
                </div>
                {couponMessage && (
                  <div className="coupon-apply-mgs mt-1" style={{ fontSize: "12px" }}>
                    {couponMessage}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Scrollable Cart Items */}
          <div className="cart-items-wrapper flex-grow-1 overflow-auto">
            {cartItems?.map((item) => (
              <div key={item.detailId} className=" p-3 border-bottom">
                <Row>
                  <Col
                    xs={2}
                    className="d-flex align-items-center justify-content-center p-1"
                  >
                    <Image
                      src={getImage(item?.img?.url, "products")}
                      fluid
                      rounded
                      style={{ maxHeight: "60px", objectFit: "contain" }} // optional styling
                    />
                  </Col>
                  <Col xs={8}>
                    <h6
                      className="mb-1 cart-items change-address-link"
                      onClick={() => {
                        viewProductInfo(item.productId, item.detailId);
                      }}
                    >
                      {item.name} - ({item.unitQty}{" "}
                      {unitMap[item.unit] || item.unit})
                    </h6>
                    <h6 className="mb-1 cart-sub-text">{`${t("pdetail1")} ${
                      item.name
                    } ${t("pdetail2")}`}</h6>
                    <div className="d-flex align-items-center mt-2">
                      <Button
                        variant="outline-danger"
                        size="sm"
                        className="rounded-circle d-flex justify-content-center align-items-center"
                        style={{ width: "20px", height: "20px", padding: 0 }}
                        onClick={() =>
                          handleQtyChange(item.productId, item.detailId, "sub")
                        }
                      >
                        -
                      </Button>
                      <span style={{ minWidth: "24px", textAlign: "center" }}>
                        {item.qty}
                      </span>
                      <Button
                        variant="outline-success"
                        size="sm"
                        className="rounded-circle d-flex justify-content-center align-items-center"
                        style={{ width: "20px", height: "20px", padding: 0 }}
                        onClick={() =>
                          handleQtyChange(item.productId, item.detailId, "add")
                        }
                      >
                        +
                      </Button>
                    </div>
                    {item.isAdjusted === 1 ? (
                      <p
                        style={{
                          fontSize: "9.5px",
                          color: "Red",
                          //marginBottom: "-10px",
                          //marginTop: "2px",
                          fontFamily: "Outfit_400",
                        }}
                      >
                        {t("qty_adjusted")}
                      </p>
                    ) : null}
                  </Col>
                  <Col xs={2} className="d-flex flex-column align-items-end">
                    <Button
                      variant="link"
                      size="sm"
                      className="text-danger p-0 mb-2"
                      onClick={() => {
                        removeItemFromCart(item.productId, item.detailId);
                      }}
                    >
                      <FaTrashAlt size={12} />
                    </Button>
                    {item.discount && item.discount > 0 ? (
                      <div className="cart-items">
                        ₹{formatNumberConditionalDecimal(
                          item.price - (item.price * item.discount) / 100,
                        )}
                      </div>
                    ) : (
                      <div className="cart-items">₹{item.price}</div>
                    )}
                  </Col>
                </Row>
              </div>
            ))}
          </div>

          <div className="px-3 mt-5 total-labels">
            {showQtyExceedMsg === true ? (
              <p
                style={{
                  fontSize: "11px",
                  color: "Red",
                  //marginTop: "-50px",
                  marginBottom: "-1px",
                  textAlign: "center",
                }}
              >
                {/* Sorry, this item is either low in stock or currently out of
                stock. */}
                {t("qty_exceeded")}
              </p>
            ) : null}
            <hr style={{ margin: "auto 0" }} />
            <div className="d-flex justify-content-between">
              <span>{t("subtotal")}:</span>
              <span>₹{subtotal.toFixed(2)}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span>{t("dis")}:</span>
              <span className="text-success">
                - ₹{Number(discount)?.toFixed(2)}
              </span>
            </div>
            <div className="d-flex justify-content-between">
              <span>{t("gst")} ({(gstRate * 100).toFixed(0)}%):</span>
              <span>₹{gst.toFixed(2)}</span>
            </div>
            {shippingLoading ? (
              <div className="d-flex justify-content-between align-items-center" style={{ marginTop: "4px" }}>
                <span style={{ fontSize: "13px", color: "#666" }}>Shipping Charges:</span>
                <span style={{ fontSize: "12px", color: "#888", display: "flex", alignItems: "center", gap: "5px" }}>
                  <Spinner animation="border" size="sm" variant="secondary" style={{ width: "12px", height: "12px" }} />
                  Calculating...
                </span>
              </div>
            ) : shippingError ? (
              <div style={{
                fontSize: "12px",
                color: "#c0392b",
                background: "#fdf2f2",
                border: "1px solid #f5c6cb",
                borderRadius: "6px",
                padding: "6px 10px",
                marginTop: "4px",
              }}>
                ⚠️ {shippingError}{" "}
                <span
                  onClick={() => setShowAddressPanel(true)}
                  style={{ color: "#1a73e8", cursor: "pointer", textDecoration: "underline", fontWeight: 600 }}
                >
                  Change Address
                </span>
              </div>
            ) : (
              <div className="d-flex justify-content-between">
                <span title={shippingNote}>
                  Shipping Charges
                  {shippingNote && (
                    <span style={{ fontSize: "11px", color: "#999", marginLeft: 4 }}>
                      ({shippingNote})
                    </span>
                  )}
                  :
                </span>
                <span>₹{shippingCharge.toFixed(2)}</span>
              </div>
            )}
            <hr style={{ margin: "auto 0" }} />
            <div className="d-flex justify-content-between fw-bold fs-6 mt-1">
              <span>{t("total")}:</span>
              <span>₹{totals.toFixed(2)}</span>
            </div>
          </div>

          {/* Info Box */}
          <div className="text-center  py-1 mt-2 mb-2 rounded modal-header-color guaranteed-text">
            {t("guaranteed")}
          </div>

          {/* Checkout Button */}
          <Button
            variant="success"
            className="w-100 p-2 mb-3 checkout-text d-flex align-items-center justify-content-center gap-2"
            onClick={() => checkout()}
            disabled={shippingLoading || !!shippingError}
          >
            {t("checkout")}
            <MdOutlineShoppingCartCheckout size={20} />
          </Button>
          </>
          )}
        </Offcanvas.Body>
      </Offcanvas>
      <MessageModal
        show={showModal}
        title={msgTitle}
        message={msgMessage}
        type={msgType} // "info" or "confirm"
        onConfirm={msgConfirmFunc}
        onCancel={() => {
          setShowModal(false);
          if (redirectHomeOnClose) {
            setRedirectHomeOnClose(false);
            closeItemCart();
            navigate("/");
          }
        }}
        showLinkButton={showLinkButtonOnDialog}
        onClick={dialogOnClickFunc}
      />
      {showLogin ? (
        <Login
          show={showLogin}
          setShowLogin={() => {
            setShowLogin();
          }}
          callback={() => callbackFromLogin()}
        />
      ) : null}
      {showUserAddress ? (
        <UserAddress
          show={showUserAddress}
          closeSignupForm={() => {
            setShowUserAddress();
          }}
          selAddressToEditId={selAddressToEditId}
          callback={() => callbackFromAddress()}
        />
      ) : null}
      <Modal
        show={showAddressPanel}
        onHide={() => setShowAddressPanel(false)}
        centered
      >
        <Modal.Header closeButton className="select-delivery-address">
          <Modal.Title className="cart-header">
            {t("Select_delivery_address")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "400px", overflowY: "auto" }}>
          {userAddress?.map((addr, idx) => (
            <div key={idx} className="border p-2 mb-2 rounded">
              <Form.Check
                type="radio"
                name="deliveryAddress"
                id={`address-${idx}`}
                s
                label={
                  <div className="total-labels">
                    <div>
                      {addr.name} ({t("email")}: {addr.email}, {t("mobile_no")}:{" "}
                      {addr.mobile_no} )
                    </div>

                    <div>
                      {t("address1")}: {addr.address1}
                    </div>
                    <div>
                      {t("address2")}: {addr.address2}
                    </div>
                    <div>
                      {t("city")}: {addr.city}, {t("state")}: {addr.state}
                    </div>
                    <div>
                      {t("pin")}: {addr.pin}
                    </div>
                  </div>
                }
                onChange={() => setSelectedAddress(addr)}
                checked={addr.is_default === 1}
              />
              <div className="mt-1 d-flex gap-3">
                <Button
                  variant="link"
                  size="sm"
                  className="edit-address-link"
                  onClick={() => {
                    editAddress(addr);
                  }}
                >
                  {t("edit")}
                </Button>

                <Button
                  variant="link"
                  size="sm"
                  className="edit-address-link"
                  onClick={() => {
                    setDefaultAdd(addr);
                  }}
                >
                  {t("make_this_default_address")}
                </Button>

                {deliveryAddress?.id !== addr?.id ? (
                  <Button
                    variant="link"
                    size="sm"
                    className="edit-address-link"
                    onClick={() => {
                      deliverToThisAddress(addr);
                    }}
                  >
                    {t("deliver_to_this_address")}
                  </Button>
                ) : (
                  <p className="selected-delivery-add">
                    ✅ {t("selected_delivery_address")}
                  </p>
                )}
              </div>
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <div>
            <Button
              onClick={() => {
                addAddress();
              }}
              className="add-new-address-btn me-2 "
            >
              <FaCheck className="me-1" size={12} />
              {t("add_new_address")}
            </Button>
            <Button
              onClick={() => {
                // showLinkButtonOnDialog ? () => checkout() : () => {};
                setShowAddressPanel(false);
              }}
              variant="danger"
              style={{ fontFmily: "Outfit_400 !important" }}
            >
              <FaTimes className="me-2" size={12} />
              {t("close")}
            </Button>
          </div>
        </Modal.Footer>
        {isLoading && <FullPageLoader />}
      </Modal>
    </>
  );
};

export default Cart;
